import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }
}))

export default useStyles
